import { render, staticRenderFns } from "./SettingPermission.vue?vue&type=template&id=0f81671f&scoped=true&"
import script from "./SettingPermission.vue?vue&type=script&lang=js&"
export * from "./SettingPermission.vue?vue&type=script&lang=js&"
import style0 from "./SettingPermission.vue?vue&type=style&index=0&id=0f81671f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f81671f",
  null
  
)

export default component.exports